import "./App.css";
import "./style/responsive.css";
import "./style/pages-responsive.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import BusinessRegistration from "./pages/BusinessRegistration";
import RiderRegistration from "./pages/RiderRegistration";
import RiderDataFetch from "./context/RiderDataFetch";
import FetchAddTransaction from "./context/FetchAddTransaction";
import PromoCode from "./pages/PromoCode";
import ReferralCode from "./pages/ReferralCode";
import Register from "./pages/Register";
import Login from "./pages/login";
import Report from "./pages/Report";
import "react-toastify/dist/ReactToastify.css";
import { useState, useEffect } from "react";
import ListingNewItems from "./pages/ListingNewItems";
import ListingNewSalesItems from "./pages/ListSaleProduct";
import FetchListedItems from "./pages/FetchListedItems";
import AddCategory from "./pages/AddCategory";
import UpdateSubCategory from "./pages/UpdateSubCategory";
import OrdersBill from "./pages/OrdersBill";
import UpdateCategories from "./pages/UpdateCategory";
import PushNotificationPage from "./pages/pushNotifications";
import OrderList from "./pages/OrderList";
import QuestionManager from "./pages/Questions";
import Leaderboard from "./pages/LeaderBoard";
import HotspotForm from "./pages/Hotspot";
import OrderQRCodeQueue from "./pages/QrCodepage";
import BannerAdmin from "./pages/Banner";
import CouponCampaignManager from "./pages/Coupons";
import { ToastProvider } from "./components/ToastContainer";
import RiderCharges from "./pages/RiderCharges";
import FreshGreens from "./pages/freshGreenCard";
import RadiusMap from "./pages/locationRadiusMap";
import StoreOrder from "./pages/emeStore";
import SeedNinjaEats from "./pages/SeedNinjaEats";
import Admin from "./pages/Admin";
import { useLocation } from "react-router-dom";
import { useUser } from "./context/adminContext";
import ProtectedRoute from "./ProtectedRoute";
import { logAdminActivity } from "./utils/activityLogger";

// Service Dashboard
import ServiceDashboard from "./pages/service/ServiceDashboard";
import ServiceRegister from "./pages/service/ServiceRegister";
import ServiceRoute from "./ServiceRoute";
import Overview from "./pages/service/Overview";
import Bookings from "./pages/service/Bookings";
import Slots from "./pages/service/Slots";
import Payments from "./pages/service/Payments";
import Settings from "./pages/service/Settings";
import Services from "./pages/service/Services";
import Technicians from "./pages/service/Technicians";
import Categories from "./pages/service/Categories";
import UserGuide from "./pages/service/UserGuide";
import AdminCategoriesServices from "./pages/Admin/AdminCategoriesServices";
import ServiceAdmin from "./pages/service/admin/ServiceAdmin";

// Restaurant Categories
import RestaurantRegister from "./pages/restaurant/RestaurantRegister";
import RestaurantAdmin from "./pages/restaurant/RestaurantAdmin";

// Certificate Management Components
import CertificateDashboard from "./pages/certificate/CertificateDashboard";
import CreateCertificate from "./pages/certificate/CreateCertificate";
import CertificateVerification from "./pages/certificate/CertificateVerification";

// No Access Page
import NoAccess from "./pages/certificate/NoAccess";

// Notification System
import { NotificationProvider } from "./context/NotificationContext";
import NotificationAlert from "./components/NotificationAlert";
import Feedback from "./pages/service/Feedback";

function App() {
  const { user, loadingUser } = useUser();
  const isAdmin =
    user &&
    (
      user.roleKey === "all_access_admin" ||
      (Array.isArray(user.permissions) && user.permissions.length > 0)
    );
  const location = useLocation();

  // Service dashboard state
  const [nav, setNav] = useState(false);
  const [is24x7, setis24x7] = useState(false);
  const [isEme, setisEme] = useState(false);

  // UI + ROLE STATE HANDLING
  useEffect(() => {
    if (user && !loadingUser) {
      setNav(true);
      // Optional future flags
      setis24x7(user.roleKey === "fresh_greens");
      setisEme(user.roleKey === "eme_store");
    } else {
      setNav(false);
      setis24x7(false);
      setisEme(false);
    }
  }, [user, loadingUser, location.pathname]);

  // ACTIVITY LOGGING
  useEffect(() => {
    if (!user) return;

    logAdminActivity({
      user,
      type: "NAVIGATION",
      module: "ROUTE",
      action: "Visited page",
      route: location.pathname,
      component: "Router",
    });
  }, [user, location.pathname]);

  // Skip global loader for service dashboard routes - they have their own loader
  const isServiceDashboardRoute = location.pathname.startsWith('/service-dashboard') || 
                                   location.pathname === '/service-register';
  
  // AdminContext already handles loading for non-service routes
  // No need for additional loader here

  return (
    <ToastProvider>
      <NotificationProvider>
        <div>
        {nav && isAdmin && <Navbar />}
        <NotificationAlert />
        <Routes>
          {/* Public Certificate Verification - No Auth Required */}
          <Route 
            path="/verify/:certificateId" 
            element={<CertificateVerification />} 
          />
          
          {/* Main Route */}
          <Route
            path="/"
            element={
              nav ? (
                isAdmin ? (
                  <Home />
                ) : isEme ? (
                  <StoreOrder />
                ) : is24x7 ? (
                  <FreshGreens />
                ) : (
                  <OrderQRCodeQueue />
                )
              ) : (
                <Login
                  setNav={setNav}
                  setIsadmin={() => {}}
                  setisEme={setisEme}
                  setis24x7={setis24x7}
                />
              )
            }
          />

          {/* Register Route */}
          <Route 
            path="/register"
            element={<Register setNav={setNav} />}
          />

          <Route
            path="/login"
            element={
              <Login
                setNav={setNav}
                setIsadmin={() => {}}
                setisEme={setisEme}
                setis24x7={setis24x7}
              />
            }
          />
          
          <Route
            path="/home"
            element={
              nav ? (
                isAdmin ? <Home /> : <Navigate to="/" />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/bussinessregistration"
            element={
              nav === true ? <BusinessRegistration /> : <Navigate to="/" />
            }
          />

          <Route
            path="/productslist"
            element={nav === true ? <FetchListedItems /> : <Navigate to="/" />}
          />

          <Route
            path="/riderregistration"
            element={nav === true ? <RiderRegistration /> : <Navigate to="/" />}
          />

          <Route
            path="/riderlist"
            element={nav === true ? <RiderDataFetch /> : <Navigate to="/" />}
          />

          <Route
            path="/addtransaction"
            element={nav === true ? <FetchAddTransaction /> : <Navigate to="/" />}
          />

          <Route
            path="/promocode"
            element={nav === true ? <PromoCode /> : <Navigate to="/" />}
          />

          <Route
            path="/referralcode"
            element={nav === true ? <ReferralCode /> : <Navigate to="/" />}
          />

          <Route
            path="/report"
            element={nav === true ? <Report /> : <Navigate to="/" />}
          />

          <Route
            path="/orderlist"
            element={nav === true ? <OrderList /> : <Navigate to="/" />}
          />

          <Route
            path="/AddItems"
            element={
              nav === true ? (
                <ProtectedRoute user={user}>
                  <ListingNewItems />
                </ProtectedRoute>
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/AddSalesItems"
            element={
              nav === true ? <ListingNewSalesItems /> : <Navigate to="/" />
            }
          />

          <Route
            path="/updatesubcategory"
            element={nav === true ? <UpdateSubCategory /> : <Navigate to="/" />}
          />

          <Route
            path="/addcategories"
            element={nav === true ? <AddCategory /> : <Navigate to="/" />}
          />

          <Route
            path="/downloadbill"
            element={nav === true ? <OrdersBill /> : <Navigate to="/" />}
          />

          <Route
            path="/categories_management"
            element={
              nav === true ? (
                <ProtectedRoute user={user}>
                  <UpdateCategories/>
                </ProtectedRoute>    
              ) : (      
                <Navigate to="/" />
              )
            } 
          />

          <Route
            path="/pushNotification"
            element={
              nav === true ? <PushNotificationPage /> : <Navigate to="/" />
            }
          />

          <Route
            path="/questions"
            element={nav === true ? <QuestionManager /> : <Navigate to="/" />}
          />

          <Route
            path="/leaderboard"
            element={nav === true ? <Leaderboard /> : <Navigate to="/" />}
          />

          <Route
            path="/hotspot"
            element={nav === true ? <HotspotForm /> : <Navigate to="/" />}
          />

          <Route
            path="/scanorder"
            element={nav === true ? <OrderQRCodeQueue /> : <Navigate to="/" />}
          />

          <Route
            path="/banner_management"
            element={nav === true ? <BannerAdmin /> : <Navigate to="/" />}
          />

          <Route
            path="/coupon_management"
            element={
              nav === true ? <CouponCampaignManager /> : <Navigate to="/" />
            }
          />

          <Route
            path="/RiderCharges"
            element={nav === true ? <RiderCharges /> : <Navigate to="/" />}
          />

          <Route
            path="/Fresh_Greens"
            element={nav === true ? <FreshGreens /> : <Navigate to="/" />}
          />

          <Route
            path="/RadiusMap"
            element={nav === true ? <RadiusMap /> : <Navigate to="/" />}
          />

          <Route
            path="/Test"
            element={nav === true ? <StoreOrder /> : <Navigate to="/" />}
          />

          <Route 
            path="/seed-ninja-eats" 
            element={nav === true ? <SeedNinjaEats /> : <Navigate to="/" />} 
          />

          <Route
            path="/admin"
            element={
              (user?.permissions?.includes("page:users") ||
                user?.roleKey === "all_access_admin")
                ? <Admin />
                : <Navigate to="/no-access" />
            }
          />

          {process.env.NODE_ENV === "development" && (
            <Route
              path="/__admin_dev"
              element={
                (user?.permissions?.includes("page:users") || user?.roleKey === "all_access_admin")
                ? <Admin />
                : <Navigate to="/no-access" />
              }
            />
          )}

          {/* Service Dashboard Routes */}
          <Route
            path="/service-dashboard"
            element={
              <ServiceRoute>
                <ServiceDashboard />
              </ServiceRoute>
            }
          >
            <Route index element={<Overview />} />
            <Route path="categories" element={<Categories />} />
            <Route path="services" element={<Services />} />
            <Route path="bookings" element={<Bookings />} />
            <Route path="slots" element={<Slots />} />
            <Route path="technicians" element={<Technicians />} />
            <Route path="payments" element={<Payments />} />
            <Route path="settings" element={<Settings />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="guide" element={<UserGuide />} />
          </Route>

          <Route
            path="/admin/categories-services"
            element={<AdminCategoriesServices />}
          />

          <Route
            path="/admin/service-admin"
            element={<ServiceAdmin />}
          />

          {/* Service Register */}
          <Route path="/service-register" element={<ServiceRegister />} />

          {/* Restaurant Register */}
          <Route path="/restaurant-register" element={<RestaurantRegister />} />

          {/* Restaurant Admin */}
          <Route path="/restaurant-admin" element={<RestaurantAdmin />} />
          
          {/* Certificate Management Routes - TEMPORARY: OPEN ACCESS FOR TESTING */}
          <Route 
            path="/certificate/dashboard" 
            element={<CertificateDashboard />} 
          />
          
          <Route 
            path="/certificate/create" 
            element={<CreateCertificate />} 
          />
          
          {/* No Access Page */}
          <Route path="/no-access" element={<NoAccess />} />
        </Routes>
        
      </div>
    </NotificationProvider>
    </ToastProvider>
  );
}

export default App;